import { Route, Routes } from 'react-router-dom'

import BookingPlanner from './screens/BookingPlanner'

const PublicationManagerRoutes = () => (
  <Routes>
    <Route path="/bookingPlanner" element={<BookingPlanner />} />
  </Routes>
)

export default PublicationManagerRoutes
